import React from 'react'
import ImageSwatch from './ImageSwatch'
import TextSwatch from './TextSwatch'
import { t } from '../utils/i18n'

interface ComponentListLogoProps {
  onClick: () => void
  active: boolean
  logoUrl?: string
}

const ComponentListLogo: React.FC<ComponentListLogoProps> = ({
  onClick,
  active,
  logoUrl
}) => {
  const className = [
    'velorbis-customizer-component',
    'velorbis-customizer-logo-component',
    active ? 'velorbis-customizer-component-active' : ''
  ].join(' ')

  return (
    <div onClick={onClick} className={className}>
      <div className="velorbis-customizer-component-name">
        {t('logo_upload')}
      </div>
      {logoUrl ? <ImageSwatch url={logoUrl} /> : <TextSwatch text="Off" />}
    </div>
  )
}

export default ComponentListLogo
